import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  ref: "bottom",
  class: "bottom"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _directive_resize = _resolveDirective("resize")

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: "root",
    onScroll: _cache[0] || (_cache[0] = $event => (_ctx.$throttle($options.handleScroll)))
  }, [
    _createElementVNode("div", {
      ref: "viewport",
      class: "viewport",
      style: _normalizeStyle($options.viewport_style)
    }, [
      _createElementVNode("div", {
        ref: "spacer",
        class: "spacer",
        style: _normalizeStyle($options.spacer_style)
      }, [
        _createVNode(_component_CollapseGroup, {
          ref: "group",
          items: $options.v_items,
          duration: $data.animate ? $setup.DURATION : 0
        }, {
          default: _withCtx(({ item, index }) => [
            _renderSlot(_ctx.$slots, "default", {
              item: item,
              index: index
            }, undefined, true)
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["items", "duration"]),
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "bottom", {}, undefined, true)
        ], 512 /* NEED_PATCH */)
      ], 4 /* STYLE */)
    ], 4 /* STYLE */)
  ], 32 /* NEED_HYDRATION */)), [
    [_directive_resize, $options.handleResize]
  ])
}